import {Component, Input, OnInit} from '@angular/core';
import {ParametroFuncao} from "../../../../funcao/models/parametro-funcao";
import {AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-parametro-funcao-valor-boolean',
  templateUrl: './parametro-funcao-valor-boolean.component.html',
  styleUrls: ['./parametro-funcao-valor-boolean.component.scss']
})
export class ParametroFuncaoValorBooleanComponent implements OnInit {
  constructor() { }

  @Input() schema: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    variavel: ""

  };
  @Input() schemaParent: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    variavel: ""

  };

  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() value: any;
  @Input() readonly = false;

  public formControl = new FormControl();
  public required: boolean;


  ngOnInit(): void {
    this.formControl = new FormControl(null, null);
    this.formControl.setValue(this.value)
    this.formGroup.addControl(this.schema.variavel, this.formControl);

    this.required = false;

    if (this.readonly){
      this.formControl.disable()
    }

  }

}
